import { SActionBtn, SBack, SLowcodeList, STableActions } from 'shj-components'
import styles from '../index.module.less'
import { useEffect, useRef, useState } from 'react'
import DirectReFundDrawer from './refundDrawer/directIndex.tsx'
import { useParams, useNavigate } from 'react-router-dom'
import { getQuoteGoodsList, findCanRefundTrans } from '@/services/order'
import DetailModal from './detailModal/index.tsx';
import { config } from './directIndexConfig.tsx'

export default function DirectIndex() {
  const navaigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [detailOpen, setDetailOpen] = useState(false)
  const { id } = useParams()
  const listRef = useRef<any>(null)
  const [editRecord, setEditRecord] = useState({})
  const [detailId, setDetailId] = useState('')
  const [stateDisplay, setStateDisplay] = useState('')
  const [isBackTrack, setIsBackTrack] = useState(false)

  const findRefundTrans = async (orderId: string) => {
    const res: any = await findCanRefundTrans({
      orderId,
      refundType: 'refundTypeRetailAmount'
    })
    setIsBackTrack(res.backTrackFlag);
  }

  const onEdit = async record => {
    try {
      await findRefundTrans(id || '');
      setEditRecord(record);
      setOpen(true)
    } catch (err) {
      console.log(err);
    }
  }
  const onDetail = async record => {
    try {
      setDetailId(record?.goodsId);
      setStateDisplay(record?.stateDisplay);
      setDetailOpen(true)
    } catch (err) {
      console.log(err);
    }
  }
  const fetchList = values => {
    return new Promise(async (resolve, reject) => {
      try {
        const data: any = await getQuoteGoodsList({
          data: {
            orderId: id,
          },
        })
        console.log(data)
        resolve({ records: data, total: data.length, success: true })
      } catch (err) {
        reject({ success: false })
      }
    })
  }
  const extensions = {
    request: { fetchList },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            { (record.buttons && record.buttons?.findIndex(item => item.buttonKey === 'REFUND_DETAIL_BTN') !== -1) && (
              <SActionBtn onClick={() => onDetail(record)}>退款详情</SActionBtn>
            )}
            { (record.buttons && record.buttons?.findIndex(item => item.buttonKey === 'REFUND_BTN') !== -1) && (
              <SActionBtn onClick={() => onEdit(record)}>退款</SActionBtn>
            )}
            {/* {['refunding'].includes(record?.state) && (
              <SActionBtn onClick={() => onEdit(record)}>取消退款</SActionBtn>
            )} */}
          </STableActions>
        )
      },
    },
  }

  const goBack = () => {
    navaigate('/order/list')
  }

  return (
    <SBack title={'订单详情'} level={2} goPath={goBack}>
      <div className={styles.tableBox}>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        {open ? <DirectReFundDrawer title="申请退款" listRef={listRef} isBackTrack={isBackTrack} open={open} setOpen={setOpen} editRecord={editRecord}></DirectReFundDrawer> : null}
        {detailOpen ? <DetailModal stateDisplay={stateDisplay} editId={detailId} open={detailOpen} onClose={() => { setDetailOpen(false) }} /> : null}
      </div>
    </SBack>
  )
}
